import { Typography } from '@mui/material'
import React, { memo, useContext } from 'react'
import tw from 'twin.macro'
import EmptyImage from 'src/assets/images/empty-clipboard.svg'
import EmptySearchImage from 'src/assets/images/empty-search.svg'
import { colors } from 'src/theme'
import { AssignContractorsTableContext } from './AssignContractorsTable.context'
import { Button } from 'src/components/shared/Button'
import { ExternalMinor } from '@shopify/polaris-icons'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from 'src/constants/routes'

const EmptyAssignContractorsComponent = () => {
  const { searchQuery, tagsFilter } = useContext(AssignContractorsTableContext)

  const navigate = useNavigate()

  const isSearchUsed = Boolean(searchQuery || tagsFilter.length)

  const handleOnboardingClick = () => {
    navigate(ROUTES.CONTRACTOR_ONBOARDINGS_URL)
  }

  return (
    <div css={tw`flex flex-1 h-full justify-center items-center flex-col`}>
      <img src={isSearchUsed ? EmptySearchImage : EmptyImage} />
      <Typography css={tw`mt-2 w-[270px] text-center`} variant="h4" fontWeight={600}>
        {isSearchUsed ? 'No contractors found to assign' : 'This board is empty'}
      </Typography>
      <Typography
        css={tw`mb-4 w-[270px] text-center`}
        color={colors.SHADES_GREY_400}
        variant="body2"
      >
        {isSearchUsed
          ? 'Please try a different search query or filters.'
          : 'Invite more contractors to expand your fleet.'}
      </Typography>
      <Button
        color="white"
        size="small"
        endIcon={<ExternalMinor width={20} />}
        onClick={handleOnboardingClick}
      >
        Onboarding page
      </Button>
    </div>
  )
}

export const EmptyAssignContractors = memo(EmptyAssignContractorsComponent)
